import { TJackpot } from '../types';

export const updateAmount = (
    data: TJackpot,
    interval: number
) => {
    if (!data.amountStartTime || !data.amount || !data.step) {
        return {};
    }

    const now = Date.now();
    const timeDiff = now - data.amountStartTime;
    const newAmount = data.amount + (timeDiff / interval * data.step || 0);

    // if jackpot reach limit
    if (data.isZeroStep && data.originAmount && data.originAmount <= newAmount) {
        return {
            amount: data.originAmount
        };
    }

    if (timeDiff >= interval && data.amount !== newAmount) {
        return {
            amount: newAmount,
            amountStartTime: now,
            isReachLimit: true
        };
    }

    return {};
};
